import { Component, OnInit, ElementRef, ViewChild } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import 'rxjs/add/operator/debounceTime';
import { AuthService } from "../../auth.service";
import { AppCommonService } from "../../appcommon.service";
import { GlobalService } from "../../global.service";
import { HeaderAndNavigationService } from "../headerandnavigation.service";
import { LoaderService } from "../../LoaderService";
declare var $: any;


@Component({
    selector: '[mft-servicespostlogin]',
    templateUrl: './servicespostlogin.component.html'
})
export class ServicesPostloginComponent {    
    constructor(
        private fb: FormBuilder,
        private authService: AuthService,
        private appCommonService: AppCommonService,
        private router: Router,
        public globalService: GlobalService,
        public headerAndNavigationService: HeaderAndNavigationService,
        public loaderService: LoaderService,

    ) { }

    ngOnInit(): void {             
        
    }    
}



// WEBPACK FOOTER //
// ./src/app/headerandnavigation/services/servicespostlogin.component.ts